export default __webpack_public_path__ + "static/media/section3-pic6.9fbb4739.png";